import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ProfileIdentity from './ProfileIdentity';
import ProfileIdentityV2 from '../ProfileIdentity.group_profiles';
import ProfileIdentityContainer from './ProfileIdentity.container';

export default withFeatureBranch({ group_profiles: ProfileIdentityV2 })(
  ProfileIdentityContainer(ProfileIdentity)
);
